import { useState } from 'react'
import { Input } from 'reactstrap'

export default function MonthSelectInput({ name, changeHandler, defaultValue, style }) {
  console.log(`MonthSelectInput rendered: ${name}`)
  const [value, setValue] = useState(defaultValue)

  function handleChange(event) {
    console.log('MonthSelectInput.handleChange', event)
    const selectedValues = []
    for (let option of event.target.selectedOptions) {
      selectedValues.push(option.value)
    }
    event.selectedValues = selectedValues
    changeHandler(event)
    setValue(selectedValues)
  }

  const options = []
  options.push(<option key={1} value={1}>January</option>)
  options.push(<option key={2} value={2}>February</option>)
  options.push(<option key={3} value={3}>March</option>)
  options.push(<option key={4} value={4}>April</option>)
  options.push(<option key={5} value={5}>May</option>)
  options.push(<option key={6} value={6}>June</option>)
  options.push(<option key={7} value={7}>July</option>)
  options.push(<option key={8} value={8}>August</option>)
  options.push(<option key={9} value={9}>September</option>)
  options.push(<option key={10} value={10}>October</option>)
  options.push(<option key={11} value={11}>November</option>)
  options.push(<option key={12} value={12}>December</option>)

  return (
    <Input
      style={style}
      type="select"
      name={name}
      bsSize="sm"
      onChange={handleChange}
      value={value}
    >
      {options}
    </Input >
  )
}